import { render, staticRenderFns } from "./EgdsView.vue?vue&type=template&id=381dfe4d"
import script from "./EgdsView.vue?vue&type=script&lang=js"
export * from "./EgdsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports